module.exports = __webpack_public_path__ + "static/media/got2.701f9d84.jpg";